import { put, race, call, putResolve } from 'redux-saga/effects'
import { createSagasActions } from 'utils/sagas'
import {
  init as initState,
  setLoadStatus
} from '../redux/view'
import viewError from 'store/sagas/viewError'

export const NAMESPACE = 'KanBo/UserGroups/sagas/'
export const STOP_SAGA = NAMESPACE + 'STOP_SAGA'
export const FETCH_USER_GROUPS = NAMESPACE + 'FETCH_USER_GROUPS'
export const REQUEST_ADD_USER_GROUP = NAMESPACE + 'REQUEST_ADD_USER_GROUP'
export const REQUEST_ADD_USERS_FROM_FILE_TO_GROUP = NAMESPACE + 'REQUEST_ADD_USERS_FROM_FILE_TO_GROUP'
export const REQUEST_ADD_USER_TO_GROUP = NAMESPACE + 'REQUEST_ADD_USER_TO_GROUP'
export const REQUEST_REMOVE_USER_FROM_GROUP = NAMESPACE + 'REQUEST_REMOVE_USER_FROM_GROUP'
export const REQUEST_REMOVE_USER_GROUP = NAMESPACE + 'REQUEST_REMOVE_USER_GROUP'
export const REQUEST_RESYNC_SYNC_TARGET_USERS = NAMESPACE + 'REQUEST_RESYNC_SYNC_TARGET_USERS'

const { getSagas, actionCreators } = createSagasActions([
  [FETCH_USER_GROUPS, 'fetchUserGroups', require('./fetchUserGroups').default, { takeLatest: true }],
  [REQUEST_ADD_USER_GROUP, 'requestAddUserGroup', require('./requestAddUserGroup').default],
  [REQUEST_ADD_USERS_FROM_FILE_TO_GROUP, 'requestAddUsersFromFileToGroup', require('./requestAddUsersFromFileToGroup').default],
  [REQUEST_ADD_USER_TO_GROUP, 'requestAddUserToGroup', require('./requestAddUserToGroup').default],
  [REQUEST_REMOVE_USER_FROM_GROUP, 'requestRemoveUserFromGroup', require('./requestRemoveUserFromGroup').default],
  [REQUEST_REMOVE_USER_GROUP, 'requestRemoveUserGroup', require('./requestRemoveUserGroup').default],
  [REQUEST_RESYNC_SYNC_TARGET_USERS, 'requestResyncSyncTargetUsers', require('./requestResyncSyncTargetUsers').default]
])

actionCreators.stopSaga = () => {
  return {
    type: STOP_SAGA
  }
}

export const sagaActions = actionCreators

export function * userGroupsActionsListener () {
  try {
    yield race([
      ...getSagas(),
    ])
  } catch (error) {
    yield putResolve(viewError({
      error,
      refresh: true
    }))
  }
}

export function * stop () {
  yield put(sagaActions.stopSaga())

  return
}

export function * init () {
  try {
    yield put(initState({
      loading: true,
      loaded: false
    }))

    yield put(setLoadStatus({
      loading: false,
      loaded: true
    }))
  } catch (error) {
    yield putResolve(viewError({
      error,
      refresh: true
    }))
  }
}
